/**
 * Centralised URL constants for the SDK CDN and backend API.
 *
 * To change the production URLs, update the defaults below.
 * To override at build/deploy time, set these environment variables:
 *   VITE_SDK_CDN_URL  — SDK CDN script URL
 *   VITE_API_URL      — API base URL
 */

const firebaseProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;

export const SDK_CDN_URL =
  import.meta.env.VITE_SDK_CDN_URL ?? 'https://prelaunchwaitlist.com/v1/plw.js';

export const API_URL =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.DEV
    ? `http://localhost:5001/${firebaseProjectId}/us-central1/api`
    : 'https://prelaunchwaitlist.com/api');
